
const RecurringInvoiceStarter = ({ setCreateInvoice }) => {
    return (
        <div className="_2fnj">
            <div className="clarions-pods">
                <h3>Generate. Establish. Repeat.</h3>
                <span className="frumpy-gel">Set up repetitive expenses to manage and pay for items you regularly spend on.</span>
                <button onClick={() => setCreateInvoice(true)}>Create New Recurring Invoice</button>
            </div>
        </div>
    )
}

export default RecurringInvoiceStarter

